import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
//import { AnyAaaaRecord } from 'node:dns';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IMessageDetails } from '../class/largereceipt';
import { CommonUtilService } from '../service/common-util.service';
import { LargereceiptService } from '../service/largereceipt.service';

@Injectable({
  providedIn: 'root'
})
export class MessagedetailsbyshistoryResolver implements Resolve<IMessageDetails> {
  constructor(private largeReceiptSvc: LargereceiptService,private router:Router,private commonUtilService: CommonUtilService) {

    
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IMessageDetails> {
    this.commonUtilService.DisplayAndHideSideMenu('download-authenticated-receipt');
    let historyId = route.paramMap.get('historyId');
        if (historyId=='undefined' || historyId=='0') {
            
          this.router.navigate(['/download-authenticated-receipt']);
            return of (null);
        }
        else{
            this.largeReceiptSvc.isAuthenticatedReceiptDownloadedOrNot(historyId);
            localStorage.setItem("HistoryId",historyId);
            return this.largeReceiptSvc.getMessageDetailsByHistoryId(historyId)
            .pipe(
              catchError(error => {
                let errorDescription=error;
                this.router.navigate(['/errorpage',error]);
                  return of(null);
              })
            );
        }
  }
}
